import React from 'react'
import { SearchAreaView } from './SearchAreaView'
import { ISearchArea } from './interfaces'

export const SearchArea: React.FC<ISearchArea> = ({ saveXlsx, saveCsv, isLoading }) => {
  return <SearchAreaView saveCsv={saveCsv} saveXlsx={saveXlsx} isLoading={isLoading} />
}
